var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.container }, [
    _vm.profilePictureUrl
      ? _c("img", {
          class: _vm.$style.image,
          attrs: { src: _vm.profilePictureUrl, alt: "Profile Picture" },
        })
      : _c("div", { class: _vm.$style.noImage }, [
          _c("div", {
            staticClass: "fa fa-image",
            class: _vm.$style.noImageIcon,
            attrs: { "aria-hidden": "true" },
          }),
          _c("div", { class: _vm.$style.noImageLabel }, [
            _vm._v("Your Profile Picture"),
          ]),
        ]),
    _c(
      "button",
      {
        staticClass:
          "rbButton expandButtonToShowText accountProfileUploadImageButton",
        class: _vm.$style.uploadButton,
        on: { click: _vm.editPicture },
      },
      [
        _c("i", { staticClass: "material-icons" }, [_vm._v("add_a_photo")]),
        _vm._v(" "),
        _c("span", { class: _vm.$style.uploadButtonLabel }, [_vm._v("Upload")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }